import { memo, useMemo } from 'react';
import { Col, Form, Row } from 'antd';
import { FormikProps } from 'formik';
import { RcCustomRequestOptions } from '@Components/types/UploadType';
import { ITRequestFormValues } from '@Features/EmployeeSelfService/requests/ITRequisition/form/type';
import { Attachment } from '@Components/types/Attachment';
import { MSelect } from '@Components/Base';
import { Option, OptionNum } from '@Components/types/options';

import ConditionalFormDetails from './component/ConditionalFormDetails';
import { ITRequestItem } from '../../ITRequestItem.enum';

interface RequestDetailsSectionProps {
  formik: FormikProps<ITRequestFormValues>;
  label: string;
  requisitionItems: OptionNum[];
  itAccessories: Option[];
  simCapValues: OptionNum[];
  splittedUserName: Array<string>;
  onFileRequest?: (options: RcCustomRequestOptions) => void;
  onFileRemove?: () => void;
  uploadedFile?: Attachment;
  onUploadedFileRemove?: (value: boolean | undefined) => void;
  formApproval?: boolean;
  onItReqTypeChange?: (value: number) => void;
  organizations: Option[];
  projects: Option[];
  onModuleChange?: (value: string[]) => void;
  isModalOpened: boolean;
  onModalCancel: () => void;
  onModalSubmit: () => void;
}

const RequestDetailsSection: React.FC<RequestDetailsSectionProps> = ({
  formik,
  formApproval,
  requisitionItems,
  itAccessories,
  simCapValues,
  splittedUserName,
  onFileRequest,
  onFileRemove,
  uploadedFile,
  onUploadedFileRemove,
  onItReqTypeChange,
  organizations,
  projects,
  onModuleChange,
  isModalOpened,
  onModalCancel,
  onModalSubmit,
}) => {
  // TODO: Remove when will ready
  const filteredReqItems = useMemo(
    () =>
      requisitionItems.filter(
        (reqItem) =>
          ![ITRequestItem.ASSET_STATUS_CHANGE].includes(
            reqItem.label as ITRequestItem
          )
      ),
    [requisitionItems]
  );

  if (!requisitionItems && !itAccessories && !simCapValues) return null;

  const { itReqType } = formik.values;

  // TODO: Remove when will ready
  const requisitionItem = itReqType
    ? filteredReqItems.find((item) => item.value === itReqType)?.label || ''
    : '';

  // const requisitionItem = itReqType
  //   ? requisitionItems.find((item) => item.value === itReqType)?.label || ''
  //   : '';

  const { itReqType: itReqTypeTouched } = formik.touched;
  const { itReqType: itReqTypeError } = formik.errors;

  return (
    <Row>
      <Col span={24}>
        <Form.Item
          label="Requisition Item"
          validateStatus={itReqTypeError && itReqTypeTouched ? 'error' : ''}
          help={itReqTypeError && itReqTypeTouched ? itReqTypeError : ''}
        >
          <MSelect
            labeloption="Requistion Item"
            value={itReqType}
            options={filteredReqItems}
            // options={requisitionItems}
            onChange={(selectValue) => {
              formik.setFieldValue('itReqType', selectValue);
              onItReqTypeChange?.(selectValue);
            }}
            onBlur={() => {
              formik.setFieldTouched('itReqType', true);
            }}
            disabled={formApproval}
            placeholder="Select Requisition Item"
          />
        </Form.Item>
      </Col>

      <ConditionalFormDetails
        requisitionItem={requisitionItem}
        itAccessories={itAccessories}
        formik={formik}
        simCapValues={simCapValues}
        formApproval={formApproval}
        splittedUserName={splittedUserName}
        onFileRequest={onFileRequest}
        onFileRemove={onFileRemove}
        uploadedFile={uploadedFile}
        onUploadedFileRemove={onUploadedFileRemove}
        organizations={organizations}
        projects={projects}
        onModuleChange={onModuleChange}
        isModalOpened={isModalOpened}
        onModalCancel={onModalCancel}
        onModalSubmit={onModalSubmit}
      />
    </Row>
  );
};

export default memo(RequestDetailsSection);
